import { useEffect, useRef, useState } from 'react'
import { Container, Row, Col } from '@ui/wrapper'
import {
  SectionWrapper,
  StyledText,
  UnderlinedLink,
  SwiperWrapper,
  SlideItemWrapper,
  SlideItemWrapperFull,
  ButtonWrapper,
  CategorySectionWrapper,
  CategoryBGCircle,
  CategoryWrapper,
  CategoryIconWrapper,
  JuryContainerWrapper
} from './style'
import SwiperSlider, { SwiperSlide } from '@ui/swiper'
import TeamMember from '@components/team-member'
import Image from '@ui/image'
import Modal from 'react-bootstrap/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf } from '@fortawesome/pro-regular-svg-icons/faFilePdf'
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight'
import { faX } from '@fortawesome/pro-duotone-svg-icons/faX'
import { faAward } from '@fortawesome/pro-solid-svg-icons/faAward'
import './style.css'

const BSWPreisFuerWirtschaftsJournalismusArea = ({
  data,
  dataSlider,
  dataCategory,
  dataJury,
  ...rest
}) => {
  const [show, setShow] = useState(false)
  const [clickedSlideIndex, setClickedSlideIndex] = useState(0)
  const [currentSlideIndex, setCurrentSlideIndex] = useState(1)

  const swiperRef = useRef(null)
  const timeoutRef = useRef(new Array(dataJury?.items?.length).fill(null))

  const imagesLength = dataSlider?.images?.length || 0

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const scrollHandler = () => {
        let millisecondsToWait = 300

        for (let i = 0; i < dataJury?.items?.length; i++) {
          const element = document.getElementById(`animate-${i}`)
          const position = element.getBoundingClientRect()

          const isVisible =
            position.top < window.innerHeight && position.bottom >= 0
          if (isVisible) {
            if (timeoutRef.current[i] === null) {
              const element = document.getElementById(`animate-${i}`)
              timeoutRef.current[i] = setTimeout(
                () => element.classList.add('visible'),
                millisecondsToWait
              )
              millisecondsToWait += 100
            }
          }
        }
      }
      document.addEventListener('scroll', scrollHandler)
      window.addEventListener('resize', scrollHandler)

      return () => {
        document.removeEventListener('scroll', scrollHandler)
        window.removeEventListener('resize', scrollHandler)

        timeoutRef.current.forEach((timeout) => {
          if (timeout) {
            clearTimeout(timeout)
          }
        })
      }
    }
  }, [])

  const handleClose = () => {
    setShow(false)
    swiperRef.current.autoplay.start()
  }

  const handleSliderScroll = (e) => {
    let currentIndex = swiperRef.current.realIndex

    if (e.keyCode === 39) {
      currentIndex = swiperRef.current.realIndex + 1
    } else if (e.keyCode === 37) {
      currentIndex = swiperRef.current.realIndex - 1
    }

    if (!swiperRef.current.animating) {
      swiperRef.current.slideToLoop(
        (currentIndex + dataSlider?.images?.length) %
          dataSlider?.images?.length,
        1000,
        true
      )
    }
  }

  const sliderAutoplaySpeed = 1000

  const slider = {
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    rerender: 0,
    speed: 1000,
    spaceBetween: -1,
    autoplay: {
      delay: sliderAutoplaySpeed
    },
    mousewheel: false,
    keyboard: false,
    onClick: (swiper) => {
      swiper.autoplay.stop()
      setClickedSlideIndex(swiper.clickedSlide.dataset.swiperSlideIndex)
      setShow(true)
    },
    onInit: (swiper) => {
      // swiper.params.navigation.prevEl = '.prev-button'
      swiperRef.current = swiper
      swiper.params.navigation.nextEl = '.next-button'
      swiper.navigation.destroy()
      swiper.navigation.init()
      swiper.navigation.update()
      if (typeof document !== 'undefined')
        document.addEventListener('keydown', handleSliderScroll)
      setTimeout(() => {
        swiper.slideToLoop(1, sliderAutoplaySpeed)
      }, sliderAutoplaySpeed)
    },
    onDestroy: () => {
      if (typeof document !== 'undefined')
        document.removeEventListener('keydown', handleSliderScroll)
    },
    pagination: false,
    navigation: {
      prevEl: '.prev-button',
      nextEl: '.next-button'
    }
  }

  const sliderFull = {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    speed: 1000,
    spaceBetween: 0,
    autoplay: false,
    onInit: (swiper) => {
      swiper.slideToLoop(clickedSlideIndex, 0, false)
      swiper.params.navigation.prevEl = '.prev-button'
      swiper.params.navigation.nextEl = '.next-button'
      swiper.navigation.destroy()
      swiper.navigation.init()
      swiper.navigation.update()
    },
    onSlideChange: (swiper) => {
      setCurrentSlideIndex(swiper.realIndex + 1)
    },
    pagination: false,
    navigation: {
      prevEl: '.prev-button',
      nextEl: '.next-button'
    }
  }

  return (
    <>
      {data?.texts?.length > 0 && (
        <SectionWrapper {...rest}>
          <Container>
            <StyledText>
              <h4>{data.section_title?.title}</h4>
            </StyledText>
            <Row>
              <Col style={{ marginBottom: '15px', minWidth: '360px' }}>
                {data?.texts?.slice(0, 4).map((text, i) =>
                  i === 3 ? (
                    <StyledText key={i}>
                      <a
                        style={{ marginTop: 0, padding: '10px 20px 10px' }}
                        href={`mailto:${text.content}`}
                        className="btn btn-outline-primary"
                      >
                        {text.content}
                      </a>
                    </StyledText>
                  ) : (
                    <StyledText
                      key={i}
                      dangerouslySetInnerHTML={{
                        __html: text.content
                      }}
                    />
                  )
                )}
                <StyledText>
                  {data.items?.map(
                    (item, index) =>
                      item && (
                        <UnderlinedLink
                          key={index}
                          href={
                            item.pdfs[0]?.src.localFile.publicURL || item.path
                          }
                        >
                          <FontAwesomeIcon
                            icon={faFilePdf}
                            style={{ marginRight: '0.2em' }}
                          />
                          {item.title}
                        </UnderlinedLink>
                      )
                  )}
                </StyledText>
              </Col>
              <Col>
                {data?.texts?.slice(4).map((text, i) => (
                  <StyledText
                    key={i}
                    dangerouslySetInnerHTML={{
                      __html: text.content
                    }}
                  />
                ))}
              </Col>
            </Row>
          </Container>
        </SectionWrapper>
      )}
      {dataSlider.images?.length > 0 && (
        <SwiperWrapper className="own-swiper-slide">
          <SwiperSlider
            key={slider.rerender}
            options={slider}
            prevIcon="fa fa-arrow-circle-left"
            opacityStyle
          >
            {dataSlider?.images?.map(
              (image, index) =>
                image.src && (
                  <SwiperSlide
                    className="item"
                    key={'image-' + index.toString()}
                  >
                    <SlideItemWrapper
                      width={(image.src.width * 300) / image.src.height}
                    >
                      <Image
                        src={image.src.localFile || image.src}
                        alt={image?.alt || ''}
                        sizes="50vw"
                      />
                    </SlideItemWrapper>
                  </SwiperSlide>
                )
            )}
            <FontAwesomeIcon
              onClick={() => {
                const currentIndex =
                  swiperRef.current.realIndex - 1 < 0
                    ? dataSlider?.images?.length - 1
                    : swiperRef.current.realIndex - 1
                if (!swiperRef.current.animating) {
                  swiperRef.current.slideToLoop(currentIndex, 1000, true)
                }
              }}
              style={{
                borderRadius: '50%',
                color: 'white',
                width: '30px',
                height: '30px',
                padding: '10px'
              }}
              className="swiper-button-prev prev-button own-background"
              icon={faChevronLeft}
            />
            <FontAwesomeIcon
              style={{
                borderRadius: '50%',
                color: 'white',
                width: '30px',
                height: '30px',
                padding: '10px'
              }}
              className="swiper-button-next next-button own-background"
              icon={faChevronRight}
            />
          </SwiperSlider>
        </SwiperWrapper>
      )}
      <CategorySectionWrapper>
        <CategoryBGCircle layout={1} />
        <CategoryBGCircle layout={2} />
        <Container style={{ position: 'relative', zIndex: 1 }}>
          {dataCategory?.section_title?.title && (
            <StyledText
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '60px',
                marginBottom: '60px'
              }}
            >
              <h4>{dataCategory.section_title.title}</h4>
            </StyledText>
          )}
          <Row
            style={{
              marginInlineStart: '34px',
              marginInlineEnd: '34px',
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center'
            }}
          >
            {dataCategory?.items?.map((item, index) => (
              <CategoryWrapper lg={3} xs={6} key={index}>
                <CategoryIconWrapper>
                  <FontAwesomeIcon icon={faAward} />
                </CategoryIconWrapper>
                <h5 dangerouslySetInnerHTML={{ __html: item.title }} />
              </CategoryWrapper>
            ))}
          </Row>
        </Container>
      </CategorySectionWrapper>
      <JuryContainerWrapper>
        <Container>
          {dataJury?.section_title?.title && (
            <StyledText
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '80px'
              }}
            >
              <h4>{dataJury.section_title.title}</h4>
            </StyledText>
          )}
          <Row
            className="justify-content-center"
            gutters={{ lg: 60 }}
            style={{ fontSize: 14, lineHeight: 1.4 }}
          >
            {dataJury?.items?.map((member, index) => (
              <Col
                xl={2}
                lg={3}
                md={4}
                sm={6}
                key={member.id}
                mb="30px"
                style={{ padding: 10 }}
              >
                <div
                  id={`animate-${index}`}
                  className="animate"
                  style={{ height: '100%' }}
                >
                  <TeamMember
                    padding={20}
                    layout={2}
                    image={member.images?.[0]}
                    name={member.name}
                    designation={member.designation}
                    socials={member.socials}
                  />
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </JuryContainerWrapper>
      <Modal
        fullscreen
        show={show}
        onHide={handleClose}
        className="custom-modal"
      >
        <Modal.Body style={{ overflowX: 'auto' }}>
          <div style={{ color: 'white', padding: '10px' }}>
            {currentSlideIndex} / {imagesLength}
          </div>
          <SwiperWrapper style={{ width: '100%' }} className="own-swiper-slide">
            <SwiperSlider
              options={sliderFull}
              paginationTop="20px"
              opacityStyle
            >
              {dataSlider.images?.map((image, index) => (
                <SwiperSlide className="item" key={'image-' + index.toString()}>
                  <SlideItemWrapperFull>
                    <Image
                      src={image.src.localFile || image.src}
                      alt={image.src?.alternativeText || ''}
                      loading="lazy"
                      sizes="(max-width: 1000px) 100vw, 1920px"
                    />
                  </SlideItemWrapperFull>
                </SwiperSlide>
              ))}
              <FontAwesomeIcon
                style={{
                  borderRadius: '50%',
                  color: 'white',
                  width: '30px',
                  height: '30px',
                  padding: '10px'
                }}
                className="swiper-button-prev prev-button own-background"
                icon={faChevronLeft}
              />
              <FontAwesomeIcon
                style={{
                  borderRadius: '50%',
                  color: 'white',
                  width: '30px',
                  height: '30px',
                  padding: '10px'
                }}
                className="swiper-button-next next-button own-background"
                icon={faChevronRight}
              />
            </SwiperSlider>
          </SwiperWrapper>
          <ButtonWrapper onClick={handleClose} type="top-right">
            <FontAwesomeIcon icon={faX} />
          </ButtonWrapper>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default BSWPreisFuerWirtschaftsJournalismusArea
